import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function returnInventoryApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.InventorychangecallbackapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "customerId",
              type: "VARCHAR",
              require: "",
              normal: "947656354",
              describe: "apiDocDesc.customerIdDesc451"
            },
            {
              name: "changeTime",
              type: "TIME",
              require: "",
              normal: "2023-12-11 11:27:23 UTC+8",
              describe: "apiDocDesc.changeTimeDesc452"
            },
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "",
              normal: "PH01",
              describe: "apiDocDesc.warehouseCodeDesc453"
            },
            {
              name: "orderCode",
              type: "VARCHAR",
              require: "",
              normal: "INO352122342",
              describe: "apiDocDesc.orderCodeDesc454"
            },
            {
              name: "reserved1",
              type: "JSON",
              require: "",
              normal: "",
              describe: "apiDocDesc.reserved1Desc455"
            },
            {
              name: "sku",
              type: "ARRAY",
              require: "",
              normal: "",
              describe: "apiDocDesc.skuDesc456",
              children: [
                {
                  name: "itemCode",
                  type: "VARCHAR",
                  require: "",
                  normal: "AAA111",
                  describe: "apiDocDesc.itemCodeDesc457"
                },
                {
                  name: "beforeInventoryType",
                  type: "VARCHAR",
                  require: "",
                  normal: "ZP",
                  describe: "apiDocDesc.beforeInventoryTypeDesc458"
                },
                {
                  name: "afterInventoryType",
                  type: "VARCHAR",
                  require: "",
                  normal: "ZP",
                  describe: "apiDocDesc.afterInventoryTypeDesc459"
                },
                {
                  name: "quantity",
                  type: "INT",
                  require: "",
                  normal: "2",
                  describe: "apiDocDesc.quantityDesc460"
                },
                {
                  name: "batchCode",
                  type: "VARCHAR",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.batchCodeDesc461"
                },
                {
                  name: "produceCode",
                  type: "VARCHAR",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.produceCodeDesc462"
                },
                {
                  name: "remark",
                  type: "VARCHAR",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.remarkDesc463"
                },
                {
                  name: "reserved1",
                  type: "JSON",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.reserved1Desc464",
                  children: [
                    {
                      name: "totalQuantity",
                      type: "INT",
                      require: "",
                      normal: "",
                      describe: "apiDocDesc.totalQuantityDesc465"
                    }
                  ]
                }
              ]
            },
            {
              name: "requestId",
              type: "VARCHAR",
              require: "",
              normal: "8d70d8ab2768f232ebe874175065ead3",
              describe: "apiDocDesc.requestIdDesc466"
            },
            {
              name: "pushTime",
              type: "TIME",
              require: "",
              normal: "2023-12-11 11:27:23 UTC+8",
              describe: "apiDocDesc.pushTimeDesc467"
            },
            {
              name: "remark",
              type: "VARCHAR",
              require: "",
              normal: "",
              describe: "apiDocDesc.remarkDesc468"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "BOOLEAN",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc469"
            },
            {
              name: "code",
              type: "NUMBER",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.codeDesc470"
            },
            {
              name: "request_id",
              type: "STRING",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.request_idDesc471"
            },
            {
              name: "message",
              type: "STRING",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.messageDesc472"
            },
            {
              name: "data",
              type: "OBJECT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.dataDesc473"
            }
          ]
        }
      ],
      //请求示例
      requestCodes: [
        {
          title: "单sku",
          value: {
            changeTime: "2024-01-17 10:47:37",
            customerId: "CS002",
            orderCode: "SH.001_CS002_HP001_0001",
            pushTime: "2024-01-17 10:47:37",
            remark: "test",
            requestId: "c217ce79b34b436b8492bc7550406ee1",
            sku: [
              {
                afterInventoryType: "ZP",
                batchCode: "PC0001",
                beforeInventoryType: "ZP",
                itemCode: "HP001",
                produceCode: "CS021313",
                quantity: 20,
                remark: "测试11"
              }
            ],
            warehouseCode: "SH.001"
          }
        },
        {
          title: "多sku",
          value: {
            changeTime: "2024-01-09 16:50:01",
            customerId: "xp货主",
            orderCode: "xp货主_CY00000025",
            pushTime: "2024-01-24 09:40:35",
            requestId: "c94740ae95fc455a9e0ca4c5f4ba85e8",
            sku: [
              {
                afterInventoryType: "CC",
                beforeInventoryType: "standard",
                itemCode: "HP20230830001",
                quantity: -5,
                remark: ""
              },
              {
                afterInventoryType: "CC",
                beforeInventoryType: "standard",
                itemCode: "HP20230830002",
                quantity: -5,
                remark: ""
              }
            ],
            warehouseCode: "SH.001"
          }
        }
      ],
      //返回示例
      responseCode: {
        code: 0,
        message: "成功",
        request_id: "9a53af6aaeb54ceab6637df2c8805369",
        success: true
      }
    }
  };
}
